

// helpers
import type { TAssetMetaDataRecord } from "@/helpers/assets";
// local imports
import type { ADDITIONAL_EXTENSIONS } from "./extensions";

export const ADDITIONAL_ASSETS_META_DATA_RECORD: Partial<
  Record<ADDITIONAL_EXTENSIONS, TAssetMetaDataRecord>
> = {};
